<template>
  <div class="wrapper" id="wapPage">
    <div class="loginStatus">
      <div v-if="name != ''">
        <span class="themeColor">{{name}}</span>
        您好，欢迎来到小白云服！
        <span class="logout" @click="loginOut" style="color: #999999"> 退出</span>
      </div>
      <div v-else class="login"><span @click='goTo("login")'>登录/注册</span></div>
    </div>
    <header class="flex-wrap">
      <div class="flex-start">
        <div class="logo">
          <img src="../../static/images/dutyInsurance/logo.png" alt="小白保险logo" title="小白保险">
        </div>
        <div class="headline flex-end">
          <div class="index" :class="current=='index'?'currentPage':''" @click='goTo("index")'>首页</div>
          <div class="insuranceList" :class="current=='insuranceList'?'currentPage':''" @click='goTo("insuranceList")'>保险产品</div>
          <div class="about" :class="current=='about'?'currentPage':''" @click='goTo("about")'>关于我们</div>
        </div>
      </div>
      <div class="flex-end" style="float: right">
        <div class="personalCenter">
          <img src="../../static/images/home/newCrown.png" alt="" class="crown" />
          <span class="personal" style="color: #F2613F">会员中心</span>
        </div>
        <div style="padding: 0 .5rem">|</div>
        <div>客服电话：<span style="color: #F2613F">020-82526981</span></div>
      </div>
    </header>
    <main class="contentModule">
      <el-row style="padding: 20px 5%;height: 100%">
        <leftMenu />
        <transition name="router-fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </el-row>
      <el-menu class="el-menu-vertical" :collapse="false" :class="{insureInfo: true}">
        <el-menu-item index="1" @click="checkDetails(1)">
          <span slot="title">投保流程</span>
        </el-menu-item>
        <el-menu-item index="2" @click="checkDetails(2)">
          <span slot="title">保费支付说明</span>
        </el-menu-item>
        <el-menu-item index="3" @click="checkDetails(3)">
          <span slot="title">发票申请流程</span>
        </el-menu-item>
        <el-menu-item index="4" @click="checkDetails(4)">
          <span slot="title">保全流程</span>
        </el-menu-item>
      </el-menu>
    </main>
    <footer>
      <div class="introduction">
        <div class="aboutInfo space-between">
          <div class="aboutTitle">关于我们</div>
          <div class="aboutList">
            公司简介<span> | </span>专业服务<span> | </span>联系我们
          </div>
        </div>
        <div class="xiaoBaiInfo space-between">
          <div>
            <div>微博名：小白保险网</div>
            <div>微信号：xiaobaibao05</div>
            <div>邮箱：kf@xiaobiaobao.com</div>
            <div>电话：020-82526981</div>
          </div>
          <div class="flex-start QRCode">
            <div>
              <img src="../../static/images/home/AppQRCode.png">
              <div>小白宝安卓下载</div>
            </div>
            <div>
              <img src="../../static/images/home/AppQRCode.png">
              <div>小白宝苹果下载</div>
            </div>
            <div>
              <img src="../../static/images/home/serviceQrCode.png">
              <div>小白宝公众号</div>
            </div>
          </div>
        </div>
      </div>
      <div class="space-between bottomInfo">
        <div>
          <div>
            <span>版权所有：正迅保险经纪有限公司</span>
            <span>联系电话：020-82526981</span>
            <span>地址：广州市黄埔区开创大道2403号1003室</span>
          </div>
          <div>粤ICP备13035223号3</div>
        </div>
        <div class="tips">
          图片及文字免责声明
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import leftMenu from './assembly/leftMenu';
  import 'element-ui/lib/theme-chalk/display.css';
  import $$ from "../tool/BaseXJT";
  export default {
    components:{
      'leftMenu': leftMenu
    },
    name: "wapPage",
    data() {
      return {
        current: 'index',
        name: '',
      }
    },
    methods:{
      goTo(title){
        this.current = title;
        if (title == 'login'){
          if (this.$route.name == 'login') return;
          this.$router.push({name: `${title}`, query: { returnUrl: window.location.href }});
        }else {
          this.$router.push({name: `${title}`});
        }
      },
      getUserInfo() {
        let that = this;
        that.axios.post(this.UrlConfig.member_member_detailsPageMember).then((response) => {
          if (response.data.success){
            let {account, imgPath, rname} = response.data.datas;
            $('.account').html(account);

            if (that.$$.isValidObj(imgPath)) $('.imgPath').attr('src', imgPath) ;
            that.name = that.$$.isValidObj(rname) ? rname : account;
          } else {
            localStorage.removeItem(that.$$.constant.tokenKey + '_TIMING');
          }
        });
      },
      //-- 用户中心
      personalCenter() {
        this.$router.push('/wapPage');
      },
      //-- 退出登录
      loginOut() {
        let that = this;
        that.axios.post('/member/member/memberLoginOut?terminal=1').then((response) => {
          console.log(response);
          if (response.data.success == true){
            localStorage.removeItem(that.$$.constant.tokenKey + '_TIMING');
            that.axios.defaults.headers.common[that.$$.constant.tokenKey] = null;

            this.$message.success('退出成功~');
            that.name = '';
            that.$router.push({name: `index`});
          }else {
            this.$message.error(response.data.msg);
          }
        });
      },
      //-- 自动登录
      login() {
        let that = this;
        that.axios.post('/auth/member/accredit?username=18302047033&password=abc123&ltype=1&terminal=1').then((response) => {
          let data = response.data;
          const token = data[that.$$.constant.tokenKey];

          that.$$.localStorageSet(that.$$.constant.tokenKey + '_TIMING', token);
          window.location.href = 'http://localhost:8080/';
          //window.location.href = 'https://xbyftest.xiaobaibao.com/vue/#/vue'  // 测试
        });
      },
      // Q&A
      checkDetails(index) {
        let url = this.$router.resolve({
          path: '/qnaDetails',
          query: { index }
        });
        window.open(url.href, '_blank');
      },
    },
    mounted() {
     /* let token = this.$$.localStorageGet($$.constant.tokenKey + '_TIMING');
      if (this.$$.isValidObj(token)) {
        if (token != null) this.getUserInfo();
      }else {
        this.login();
      }*/
      let token = this.$$.localStorageGet($$.constant.tokenKey + '_TIMING');
      if (token != null) this.getUserInfo();

      let that = this,
        mainHeight = $('html').height() - ($('header').height() + $('.loginStatus').height());
      $('.wrapper main').css('height', mainHeight - 1);

      if (!that.$$.checkLogin()) {
        that.$$.confirm({
          message: "您还未登录，是否登录？",
          onOk: function () {
            that.goTo('login');
          },
          onCancel: function () {
            that.$router.push({name: `index`});
          }
        });
        return false;
      }

      let path = this.$route.path;
      // if (path == '/wapPage' || path == '/wapPage/') this.$router.push('/wapPage/quotationManagement');

      that.current = that.$route.name;
    }
  }

</script>
<style scoped>
  .contentModule{
    height: 100%;
    width: 100%;
    background: #f0f0f0;
  }
  .wrapper>footer{
    display: none!important;
  }

  @media (max-width: 768px) {
    .el-row{
      padding: 20px 10px 20px 0!important;
    }
  }

  .insureInfo{
    position: fixed;
    right: .5rem;
    bottom: 12rem;
  }

  /deep/ .el-menu-vertical {
    background: #f5f5f5;
    box-shadow: 0px 2px 5px 2px rgba(50, 45, 45, 0.14);
  }

  .el-menu-item{
    height: 46px;
    line-height: 46px;
    min-width: 100%;
    text-align: center;
    color: #169fed!important;
    padding-left: 10px!important;
    padding: 0 10px;
  }

  /deep/ .el-submenu__title{
    min-width: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/wapPage.vue